/** Lightweight cookie helpers for dismissible POS banners. */

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name: string, value: string, days = 7): void {
  if (typeof document === 'undefined') return;
  const maxAge = Math.max(1, Math.floor(days * 86400));
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0; SameSite=Lax`;
}

export function isBannerDismissed(cookieKey: string): boolean {
  return getCookie(cookieKey) === '1';
}

export function dismissBanner(cookieKey: string, days = 7): void {
  setCookie(cookieKey, '1', days);
}

export function restoreBanner(cookieKey: string): void {
  deleteCookie(cookieKey);
}
